module.exports = __webpack_public_path__ + "static/media/data_center_cooling.727e728d.jpg";